var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "circle_check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.104 21.121l-4.123-4.123 2.121-2.121 2.002 2.002 5.795-5.794 2.121 2.121z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27c-6.064 0-11-4.936-11-11s4.936-11 11-11 11 4.935 11 11c0 6.064-4.936 11-11 11zM16 7c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityCircleCheck);
export default __webpack_public_path__ + "static/media/unity_circle_check.e99570850d664b0fadd1b32d79349f8b.svg";
export { ForwardRef as ReactComponent };